import { track } from './analytics.js';
import { betaEventPayload } from './betaPayload.js';

// Measurement is always optional and cannot change a successful return/error.
export function createOperationObserver(emit = track, now = () => performance.now()) {
    const clock = () => { try { return now(); } catch { return Date.now(); } };
    const safeEmit = data => { try { const safe = betaEventPayload('btl_operation', data); if (safe) emit('btl_operation', safe); } catch { /* optional analytics */ } };
    return async (feature, input, operation) => {
        const started = clock();
        const base = { feature, pack_id: input?.packId || input?.rubricPackId };
        safeEmit({ ...base, outcome: 'started' });
        try {
            const result = await operation();
            const failed = result?.status === 'unavailable';
            safeEmit({ ...base, outcome: failed ? 'failed' : 'succeeded', duration_ms: clock() - started,
                result_type: result?.model === 'none' ? 'clarification' : result?.status,
                reason_code: failed ? result.reason : undefined });
            return result;
        } catch (error) {
            safeEmit({ ...base, outcome: 'failed', duration_ms: clock() - started,
                reason_code: typeof error?.code === 'string' ? error.code.replace(/^functions\//, '') : 'unknown' });
            throw error;
        }
    };
}
export const observeBetaOperation = createOperationObserver();
